//crear componente de tipo switch
import { Switch } from '@headlessui/react';
import React from 'react';
import '../../../assets/css/Text.css';
import { useStaffMode } from '../../../hooks/StaffModeProvider';

type SwitchProps = {
  seter: (checked: boolean) => void;
  checked: boolean;
  small?: boolean;
  title?: string;
  disabled?: boolean;
  centered?: boolean;
  className?: string;
  textClass?: string;
  titleFirst?: boolean;
  /** Renders the toggle before the label in normal row direction (left-aligned). */
  switchFirst?: boolean;
  name?: string;
  /** When true, checked state uses brand blue instead of member red. */
  blueChecked?: boolean;
}

const SwitchToggle: React.FC<SwitchProps> = (props) => {
  const { isStaffMode } = useStaffMode();
  const checkedBg =
    props.blueChecked || isStaffMode ? "bg-Default" : "bg-accentDefault";

  const label = (
    <span
      className={
        props.textClass
          ? `min-w-0 whitespace-nowrap ${props.textClass}`
          : "min-w-0 whitespace-nowrap text-base md:text-lg font-medium text-gray-font"
      }
    >
      {props.title}
    </span>
  );

  const toggle = (
    <Switch
      checked={props.checked}
      onChange={props.seter}
      name={props.name}
      disabled={props.disabled}
      className={`${props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}  ${props.checked ? checkedBg : 'bg-neutral '}
                relative inline-flex shrink-0 p-0.5 md:p-1 ${props.small ? 'w-11 md:w-12' : 'w-12 md:w-14'} h-6 md:h-7 gap-2 rounded-full items-center border border-solid border-gray-300 border-spacing-1 transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}>
      <span className="sr-only">Use setting</span>
      <span aria-hidden="true" className={` ${props.small ? 'w-3.5 h-3.5 md:w-4 md:h-4' : 'w-4 h-4 md:w-5 md:h-5'}  ${props.checked ? props.small ? 'translate-x-6 md:translate-x-5 bg-white' : 'translate-x-6 md:translate-x-6 bg-white' : 'translate-x-0 bg-gray-300  '}
                pointer-events-none inline-block transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out
                `}
      />
    </Switch>
  );

  const rowDirection =
    props.switchFirst || props.titleFirst ? "flex-row" : "flex-row-reverse";

  return (
    <div
      className={`flex items-center gap-2.5 w-fit ${props.centered ? "justify-center" : "justify-start"} ${rowDirection} ${props.className ?? ""}`}
    >
      {props.switchFirst ? (
        <>
          {toggle}
          {label}
        </>
      ) : (
        <>
          {label}
          {toggle}
        </>
      )}
    </div>
  );
};

export default SwitchToggle;
